export const restrictedAreas = {
    provinces: [
      // {
      //   province: 'Ifugao'
      // },
      // {
      //   province: 'Mountain Province'
      // },
      // {
      //   province: 'Marinduque'
      // },
      // {
      //   province: 'Masbate'
      // },
      // {
      //   province: 'Occidental Mindoro'
      // },
      // {
      //   province: 'Oriental Mindoro'
      // },
      // {
      //   province: 'Romblon'
      // },
      // {
      //   province: 'Sultan Kudarat'
      // },
      // {
      //   province: 'Batanes'
      // },
    ],
    cities: [
      // {
      //   province: 'Albay',
      //   city: 'Legazpi City'
      // },
      // {
      //   province: 'Aurora',
      //   city: 'Dipaculao'
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Agoncillo'
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Pulilan'
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Paombong'
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Hagonoy'
      // },
      // {
      //   province: 'Batangas',
      //   city: 'San Juan'
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Bauan'
      // },
      // {
      //   province: 'Camarines Norte',
      //   city: 'Daet'
      // },
      // {
      //   province: 'Camarines Sur',
      //   city: 'Iriga City'
      // },
      // {
      //   province: 'Camarines Sur',
      //   city: 'Naga City'
      // },
      // {
      //   province: 'Catanduanes',
      //   city: 'Virac'
      // },
      // {
      //   province: 'Laguna',
      //   city: 'Nagcarlan'
      // },
      // {
      //   province: 'Laguna',
      //   city: 'Liliw'
      // },
      // {
      //   province: 'Laguna',
      //   city: 'Cavinti'
      // },
      // {
      //   province: 'Laguna',
      //   city: 'Luisiana'
      // },
      // {
      //   province: 'Laguna',
      //   city: 'Magdalena'
      // },
      // {
      //   province: 'Quezon',
      //   city: 'Real'
      // },
      // {
      //   province: 'Quezon',
      //   city: 'Infanta'
      // },
      // {
      //   province: 'Quezon',
      //   city: 'General Nakar'
      // },
      // {
      //   province: 'Sorsogon',
      //   city: 'Sorsogon City'
      // },
      // {
      //   province: 'Tarlac',
      //   city: 'Victoria'
      // },
      // {
      //   province: 'Palawan',
      //   city: 'Narra'
      // },
      // {
      //   province: 'Palawan',
      //   city: "Brooke's Point"
      // },
      // {
      //   province: 'Palawan',
      //   city: 'Coron'
      // },
      // {
      //   province: 'Batangas',
      //   city: 'San Luis'
      // },
      // {
      //   province: 'Batangas',
      //   city: 'San Nicolas'
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'San Miguel'
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Bacoor City'
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Carmona'
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Dasmarinas City'
      // },
      // {
      //   province: 'Cavite',
      //   city: 'General Trias City'
      // },
    ],
    brgys: [
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Pag-Asa',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Tala',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Masantol',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Balut',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Silahis',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Tagumpay',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Orani',
      //   brgy: 'Talimundoc',
      // },
      // {
      //   province: 'Bataan',
      //   city: 'Hermosa',
      //   brgy: 'Almacen',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Malolos City',
      //   brgy: 'Santol',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Malolos City',
      //   brgy: 'Taal',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Malolos City',
      //   brgy: 'Niugan',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Malolos City',
      //   brgy: 'Sta Isabel',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Malolos City',
      //   brgy: 'Balite',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Baliuag',
      //   brgy: 'Calantipay',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Baliuag',
      //   brgy: 'Paitan',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Baliuag',
      //   brgy: 'Pagala',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Baliuag',
      //   brgy: 'San Roque',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Baliuag',
      //   brgy: 'Little Baguio',
      // },
      // {
      //   province: 'Bulacan',
      //   city: 'Balagtas',
      //   brgy: 'Balagtas Mc Arthur Highway',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'Floridablanca',
      //   brgy: 'Nabuclod',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'Floridablanca',
      //   brgy: 'Mawacat',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'San Fernando City',
      //   brgy: 'San Jose',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'San Fernando City',
      //   brgy: 'San Isidro',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'San Fernando City',
      //   brgy: 'Maimpis',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'San Fernando City',
      //   brgy: 'Saguin',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'San Fernando City',
      //   brgy: 'San Nicolas',
      // },
      // {
      //   province: 'Pampanga',
      //   city: 'Arayat',
      //   brgy: 'San Mateo',
      // },
      // {
      //   province: 'Zambales',
      //   city: 'San Antonio',
      //   brgy: 'Pundaquit',
      // },
      // {
      //   province: 'Zambales',
      //   city: 'San Antonio',
      //   brgy: 'San Miguel',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Santo Domingo',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santo Tomas City',
      //   brgy: 'San Francisco',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Salong',
      // },
      // {
      //   province: 'Metro Manila',
      //   city: 'Quezon City',
      //   brgy: 'Payatas',
      // },
      // {
      //   province: 'Metro Manila',
      //   city: 'Quezon City',
      //   brgy: 'Tandang Sora',
      // },
      // {
      //   province: 'Palawan',
      //   city: 'Roxas',
      //   brgy: 'San Jose',
      // },
      // {
      //   province: 'Palawan',
      //   city: 'Roxas',
      //   brgy: 'Abaroan',
      // },
      // {
      //   province: 'Palawan',
      //   city: 'San Vicente',
      //   brgy: 'Port Barton',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Alitagtag',
      //   brgy: 'Dalipit East',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Alitagtag',
      //   brgy: 'Dalipit West',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Balayan',
      //   brgy: 'Baclaran',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Balayan',
      //   brgy: 'Gimalas',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Balayan',
      //   brgy: 'Pooc',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Dalig',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Dumantay',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Gulod Itaas',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Ilihan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Libjo',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Mabacong',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Paharang Kanluran',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Pinamucan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'San Isidro',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Simlong',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Batangas City',
      //   brgy: 'Tabangao Ambulong',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 1',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 2',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 3',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 4',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 5',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Barangay 6',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Camastilisan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Lumbang Calzada',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Puting Bato East',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Puting Bato West',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Calaca',
      //   brgy: 'Quisumbing',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lemery',
      //   brgy: 'Maligaya',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lemery',
      //   brgy: 'Sambal Ibaba',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lemery',
      //   brgy: 'Sambal Ilaya',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lemery',
      //   brgy: 'Wawa Ibaba',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Bulacnin',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Lumbang',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Munting Pulo',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Pangao',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Poblacion Barangay 3',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'San Benito',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'San Celestino',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'San Francisco',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Santo Nino',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Talisay',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Tangob',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Tanguay',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Lipa City',
      //   brgy: 'Tibig',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Nasugbu',
      //   brgy: 'Barangay 12',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Nasugbu',
      //   brgy: 'Barangay 7',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Nasugbu',
      //   brgy: 'Bucana',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Nasugbu',
      //   brgy: 'Pantalan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Nasugbu',
      //   brgy: 'Talangan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Rosario',
      //   brgy: 'Malaya',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Rosario',
      //   brgy: 'Marilag',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Rosario',
      //   brgy: 'Santa Cruz',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Rosario',
      //   brgy: 'Timbugan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santa Teresita',
      //   brgy: 'Cuta East',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santa Teresita',
      //   brgy: 'Pacifico',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santa Teresita',
      //   brgy: 'Pacifico',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santo Tomas City',
      //   brgy: 'San Francisco',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santo Tomas City',
      //   brgy: 'San Luis',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Santo Tomas City',
      //   brgy: 'Santa Ana',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Ambulong',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Bagumbayan',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Bilog-Bilog',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Hidalgo',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Janopol',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Luyos',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Mabini',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Natatas',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Sala',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'San Jose',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Santor',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Sulpoc',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Talaga',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Tinurik',
      // },
      // {
      //   province: 'Batangas',
      //   city: 'Tanauan City',
      //   brgy: 'Trapiche',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Banaba Lejos',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Bancod',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Buna Lejos II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Guyam Munti',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Harasan',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Kayquit III',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Kaytambog',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Kaytapos',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Limbon',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Mahabangkahoy Cerca',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Indang',
      //   brgy: 'Tambo Balagbag',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Acacia',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Anahaw I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Anahaw II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Banaba',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Barangay I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Barangay II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Barangay III',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Barangay IV',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Barangay V',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Biga II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Bulihan',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Ipil I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Ipil II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Maguyam',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Narra I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Narra II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Narra III',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Sabutan',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'San Miguel I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'San Miguel II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'San Vicente I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'San Vicente II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Tartaria',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Tubuan I',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Tubuan II',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Tubuan III',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Silang',
      //   brgy: 'Yakal',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Tanza',
      //   brgy: 'Bagtas',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Trece Martires City',
      //   brgy: 'Aguado',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Trece Martires City',
      //   brgy: 'Conchu',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Trece Martires City',
      //   brgy: 'Gregorio',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Trece Martires City',
      //   brgy: 'Lallana',
      // },
      // {
      //   province: 'Cavite',
      //   city: 'Trece Martires City',
      //   brgy: 'Osorio',
      // },
    ]
}


/** WEBPACK FOOTER **
 ** ./src/constants/restrictedAreas.js
 **/